import PropTypes from 'prop-types';
import React from 'react';

import { translate as t } from '../../lib/I18n';
import Smartcard from '../../records/customer/Smartcard';

import SmartcardStatus from './Status';


function PassengerDetails ({ smartcard }) {
    return (
        <section className="booking__section booking__section--summary border--top border--bottom">
            <header>
                <h2>{ t('global.passenger') }</h2>
            </header>

            <p>
                { smartcard.isChild() ?
                    t('booking.smartcard.passenger.child') :
                    t('booking.smartcard.passenger.adult')
                }
            </p>

            { smartcard.railcard &&
                <div>
                    <header>
                        <h2>{ t('booking.smartcard.railcard') }</h2>
                    </header>

                    <p>{ smartcard.railcard.name }</p>
                </div>
            }

            <SmartcardStatus smartcard={ smartcard } />
        </section>
    );
}


PassengerDetails.propTypes = {
    smartcard: PropTypes.instanceOf(Smartcard).isRequired
};


export default PassengerDetails;



// WEBPACK FOOTER //
// ./src/components/smartcard/PassengerDetails.js